var map = {
	"./Caterpillar1_hero.jpg": 312,
	"./Caterpillar2_heo.jpg": 49,
	"./Sany_hero.jpg": 959,
	"./Volvo_hero.jpg": 88,
	"./vladimir-patkachakov-Mx6Xmf_nbRk-unsplash.jpg": 683,
	"./zayh-sho-n6dpoztQ2FY-unsplash.jpg": 917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 628;